module.exports = __webpack_public_path__ + "static/img/people4.992a184.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people4.jpg
// module id = nXy9
// module chunks = 1